<template>
  <section class="infraestructura">
    <p class="titleColorSystem">Equipo Especializado</p>
    <div class="sci-inf-content">
      <table class="sci-inf-table">
        <thead class="sci-inf-thead">
          <v-flex d-flex xs12 sm12 md5>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Buscar nombre, marca, modelo, tipo, descripción..."
              clearable
              flat
              @click:clear="limpiarCampos(page)"
              :hint="`Se Encontraron
                ${infCount ? infCount : 0}
                Resultados`"
              @keyup.enter.native="
                getEquipos(page, search), getEquiposExcel(page, search)
              "
            ></v-text-field>
          </v-flex>
          <!-- <v-flex d-flex xs12 sm12 md12>
            <v-layout row wrap>
              <ul class="grey--text" v-if="infCount">
                Se encontraron
                {{
                  infCount
                }}
                Resultados
              </ul>
              <ul class="grey--text" v-else>
                Sin resultados
              </ul>
            </v-layout>
          </v-flex> -->

          <span class="sci-inf-count">
            <vue-excel-xlsx
              v-if="equipos.data.length > 0"
              class="sci-inf-excel"
              :data="equiposExcelData"
              :columns="columns"
              :filename="'Equipos Especializados'"
              :sheetname="'Equipos Especializados'"
            >
              Descargar resultados
            </vue-excel-xlsx>
          </span>
          <tr class="sci-inf-tr1-equipo">
            <td>Institución</td>
            <td>Nombre del equipo</td>
            <td>Marca</td>
            <td>Modelo</td>
            <td>Ubicacion</td>
            <td></td>
            <td>Contacto</td>
          </tr>
        </thead>
        <span v-if="!infCount">
          <h3 class="font-weight-thin mb-3">SIN INFORMACIÓN</h3>
          <h4 class="subheading">POR FAVOR REALICE UNA BÚSQUEDA</h4>
        </span>
        <tbody v-else id="tbody" class="sci-inf-tbody">
          <tr v-for="(equipo, index) in equipos.data" :key="index">
            <span class="sci-inf-tr2-equipo">
              <td class="sci-inf-tr2-td">
                {{
                  equipo.institucion_academica
                    ? equipo.institucion_academica.nombre
                    : ""
                }}
              </td>
              <td class="sci-inf-tr2-td">
                {{ equipo.nombre ? equipo.nombre : "" }}
              </td>
              <td class="sci-inf-tr2-td">
                {{ equipo.marca ? equipo.marca : "" }}
              </td>
              <td class="sci-inf-tr2-td">
                {{ equipo.modelo ? equipo.modelo : "" }}
              </td>
              <td class="sci-inf-tr2-td">
                {{ equipo.ubicacion ? equipo.ubicacion : "" }}
              </td>
              <td class="sci-inf-tr2-td">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      flat
                      @click.stop="$set(dialogNote, equipo.id, true)"
                    >
                      Ver mas
                    </v-btn>
                  </template>
                  <span>Click para ver mas información</span>
                </v-tooltip>

                <v-dialog
                  v-model="dialogNote[equipo.id]"
                  scrollable
                  lazy
                  max-width="500"
                  max-height="600"
                  :key="equipo.id"
                >
                  <v-card>
                    <v-card-title class="justify-content-center">
                      <span class="grey--text">{{
                        equipo.institucion_academica
                          ? equipo.institucion_academica.nombre
                          : ""
                      }}</span>
                      <span class="headline">{{ equipo.nombre }}</span>
                    </v-card-title>
                    <v-card-text>
                      <v-flex>
                        <v-textarea
                          readonly
                          label="Descripción del equipo"
                          v-model="equipo.descripcion"
                        ></v-textarea>
                      </v-flex>
                      <v-flex>
                        <v-text-field
                          label="Origen del equipo"
                          readonly
                          v-model="equipo.origen"
                        ></v-text-field>
                      </v-flex>
                      <v-flex class="text-xs-left">
                        Tipo de pruebas:

                        <div
                          v-for="(prueba, index) in equipo.tipo_de_pruebas"
                          :key="index"
                        >
                          <v-chip> {{ prueba }} </v-chip>
                        </div>
                      </v-flex>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        @click.stop="$set(dialogNote, equipo.id, false)"
                        >Cerrar</v-btn
                      >
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </td>
              <td class="sci-inf-tr2-td">
                <v-tooltip bottom>
                  <SentMailToAcademicas
                    slot="activator"
                    v-bind:institucionAcademica="equipo.institucion_academica"
                  ></SentMailToAcademicas>
                  <span>Click para enviar correo</span>
                </v-tooltip>
              </td>
            </span>
          </tr>
        </tbody>
        <v-spacer></v-spacer>
        <div class="pagination justify-content-center">
          <pagination
            :limit="vPaginator.limit"
            :data="equipos"
            @pagination-change-page="getEquipos"
          ></pagination>
        </div>
      </table>
    </div>
    <LoadingComponent :loading="dialogLoading"></LoadingComponent>
  </section>
</template>

<script>
import axios from "axios";
import SentMailToAcademicas from "./SentMailToAcademicas.vue";
import LoadingComponent from "../../components/LoadingDialog.vue";
export default {
  props: ["urlApi"],
  components: {
    SentMailToAcademicas,
    LoadingComponent,
  },
  data() {
    return {
      dialogNote: {},
      dialogLoading: false,
      page: 1,
      columns: [
        { label: "Institución", field: "institucion_nombre" },
        { label: "Nombre", field: "nombre" },
        { label: "Marca", field: "marca" },
        { label: "Modelo", field: "modelo" },
        { label: "Tipo", field: "tipo" },
        { label: "Descripción", field: "descripcion" },
        { label: "Origen", field: "origen" },
        { label: "ubicacion", field: "ubicacion" },
      ],
      search: null,
      load: 1,
      equipos: {
        current_page: 1,
        data: {
          equipos: [],
        },
      },
      equiposExcel: {},
      vPaginator: {
        limit: 10,
      },
      selected: 4,
      CurrentElement: {},
    };
  },
  created() {
    // this.getInfraestructura();
    // this.getInfraestructuraExcel();
    // this.limpiarCampos();
  },
  watch: {
    // search: function (value) {
    //   this.getInfraestructuras();
    //   this.getInfraestructurasExcel();
    // },
  },
  computed: {
    infCount() {
      return this.equipos.total;
    },
    equiposExcelData() {
      let equipos = [];
      if (this.equiposExcel.data) {
        this.equiposExcel.data.forEach((element) => {
          let equipo = {
            institucion_nombre: element.institucion_academica
              ? element.institucion_academica.nombre
              : "",
            nombre: element.nombre,
            marca: element.marca,
            modelo: element.modelo,
            tipo: element.tipo,
            descripcion: element.descripcion,
            origen: element.origen,
            ubicacion: element.ubicacion,
          };
          equipos.push(equipo);
        });
      }

      return equipos;
    },
  },
  methods: {
    getEquipos: function (page = 1) {
      this.dialogLoading = true;
      var url = process.env.VUE_APP_API_URL + `/api/equipo-especializado?page=${page}&query=${this.search}`;
      axios
        .get(url)
        .then((response) => {
          this.equipos = response.data;
        })
        .catch((error) => console.log("Error ", error))
        .finally((response) => (this.dialogLoading = false));
    },
    getEquiposExcel: function (page = 1) {
      var url = process.env.VUE_APP_API_URL + `/api/equipo-especializado?perPage=200&page=1&query=${this.search}`;
      axios
        .get(url)
        .then((response) => {
          this.equiposExcel = response.data;
        })
        .catch((error) => console.log("Error ", error));
    },

    limpiarCampos(page) {
      this.search = null;
      this.getEquipos(page), this.getEquiposExcel(page);
    },
  },
};
</script>

<style>
.sci-inf-title {
  margin: 3% auto 0%;
  text-transform: uppercase;
  color: rgba(255, 196, 0, 0.9);
  font-weight: bold;
  font-size: 1.5em;
}
.sci-inf-dot {
  font-weight: bold;
  color: rgba(0, 152, 255, 0.9);
}
.sci-inf-dot:before {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-right: 1.2%;
  border-radius: 1px 1px;
}
.sci-inf-dot:after {
  content: "";
  display: inline-block;
  width: 90px;
  height: 1px;
  background: rgba(0, 0, 0, 0.5);
  margin-left: 1.2%;
  border-radius: 0 0 0 0;
}
.sci-inf-texto {
  width: 50%;
  margin: 1% auto;
  line-height: 1.5;
}
.sci-inf-content {
  display: grid;
  grid-template-areas:
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    "sci-inf-table sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show"
    ". sci-inf-show";
  grid-template-columns: 1fr;
  margin: 0 0 4% 0;
}
.sci-inf-table {
  display: grid;
  grid-area: sci-inf-table;
  border-spacing: 0;
  margin-top: 50px;
  margin-left: auto;
  margin-right: auto;
  width: 95%;
  align-content: start;
  margin-bottom: 200px;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-inf-thead {
  background: transparent;
  color: #fff;
  padding: 15px;
}
.sci-inf-busqueda {
  color: black;
  display: grid;
  justify-content: start;
  width: 100%;
  grid-template-columns: 1fr;
  position: relative;
}
.sci-inf-busqueda input {
  background: #fff;
  width: 40%;
  height: 25px;
  margin: 0 0 13px 0;
  border-radius: 0px 0 0 0px;
  border: none;
  padding: 0 15px;
  font-size: 0.8em;
  position: relative;
  background: gainsboro;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  border: 1px solid #aaa;
}
.sci-inf-busqueda input:focus {
  outline: 0;
}
.sci-inf-busqueda input::placeholder {
  text-transform: uppercase;
}
.sci-inf-lupa {
  background: #0084ff;
  border: none;
  width: 35px;
  height: 32px;
  padding: 15px;
  border-radius: 10px 10px 10px 10px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 10px 10px 10px 10px;
  position: absolute;
  top: 0;
  left: 37%;
}
.sci-inf-lupa:before {
  display: inline-block;
  content: "";
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: relative;
  left: -6px;
  top: -12px;
}
.sci-inf-lupa:after {
  content: "";
  width: 10px;
  height: 2px;
  display: inline-block;
  background: #fff;
  transform: rotate(45deg);
  position: absolute;
  top: 18px;
  left: 17px;
}
.sci-aca-count {
  color: #0d47a1;
  font-size: 1.03rem;
  font-weight: bold;
  display: grid;
  text-align: left;
  padding: 1rem 1rem 1rem 0;
}
.sci-inf-excel {
  font-weight: bold;
  color: #0d47a1;
  font-size: 1.1rem;
  border: 1px solid #ccc;
  padding: 0.4rem;
  margin: 1rem 0 0rem 0;
  border-radius: 5px;
  display: grid;
  width: 100%;
}
.sci-inf-count {
  color: #0d47a1;
  font-size: 1.03rem;
  font-weight: bold;
  display: grid;
  text-align: left;
  padding: 1rem 1rem 1rem 0;
}
.sci-inf-tr1-equipo {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr 2fr 2fr 1fr;
  text-transform: uppercase;
  text-align: left;
  font-weight: 100;
  color: #000;
  background-color: gainsboro;
  border-radius: 5px 5px 5px 5px;
  -moz-border-radius: 10px 10px 10px 10px;
  -webkit-border-radius: 5px 5px 5px 5px;
}
.sci-inf-tbody {
  text-align: left;
}
.sci-inf-tr2-equipo {
  display: grid;
  grid-template-columns: 2fr 2fr 2fr 2fr 2fr 2fr 1fr;
  padding: 10px;
  text-transform: uppercase;
}
.sci-inf-tr2-td {
  cursor: pointer;
  padding: 10px;
  text-overflow: ellipsis;
  overflow: hidden;
}
.active {
  background-color: rgba(0, 132, 255, 1);
  color: rgba(255, 196, 0, 1);
  font-weight: bold;
}
.sci-inf-anchor {
  text-overflow: ellipsis;
  display: flex;
  max-width: 210px;
}
.sci-inf-show {
  width: 96%;
  margin-top: 50px;
  display: grid;
  grid-area: sci-inf-show;
  background: rgba(245, 245, 245, 1) !important;
  border-radius: 0px 10px 0px 10px;
  -webkit-border-radius: 0px 10px 0px 10px;
  text-transform: uppercase;
}
.sci-inf-show2 {
  height: 340px;
}
.sci-inf-nameInf {
  text-align: center;
  width: 90%;
  max-height: 100px;
  margin: 2% auto 0;
  color: rgba(0, 132, 255, 1);
  font-size: 1.3em;
  padding: 5px 0 0 0;
}
.sci-inf-cont-info {
  display: grid;
  grid-template-columns: 1fr;
  width: 100%;
}
.sci-inf-inf1-container {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.sci-inf-info1 {
  display: grid;
  width: 100%;
  margin: 0 auto;
}
.sci-inf-inf1-container {
  padding: 0;
}
.sci-inf-info1 div,
.sci-inf-info2 div {
  padding: 15px 0;
  color: #000;
}
.sci-inf-info1-p1,
.sci-inf-info1-p2,
.sci-inf-info1-p3,
.sci-inf-info1-p4 {
  text-transform: uppercase;
  font-weight: bold;
  color: #000;
}
.sci-inf-info1-3 {
  padding: 0 0 5px 0;
}
.sci-inf-info2 {
  display: grid;
  color: #000;
}
.sci-inf-info2-p1,
.sci-inf-info2-p2,
.sci-inf-info2-p3,
.sci-inf-info2-p4 {
  text-transform: uppercase;
  font-weight: bold;
  color: #000;
}
</style>
